var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import * as styles from "./index.module.css";
import { PanelStateCssEditor } from "../../../../../../lib/comps/PropPanel/StylePanel/comps/PanelStateCssEditor/index";
import { SelectorRenameForm } from './SelectorRenameForm';
import { invoke } from "lodash-es";
import { highlightRect } from "../../../../../../lib/utils/browser";
import { delay } from "../../../../../../lib/utils";
import { ConditionStyleList } from './ConditionStyleList';
let CssEditorList = class CssEditorList extends Vue {
  constructor() {
    super(...arguments);
    this.unWatchSelector = () => void 0;
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  created() {
    // 选择器有变更的时候滚动一下把输入框置于屏幕内
    this.unWatchSelector = this.$watch(() => `${this.stylePanelState.currentSelector}-${this.stylePanelState.currentPseudoClass}`, newValue => {
      const styleInput = this.$refs[newValue];
      invoke(styleInput, 'scrollIntoView', {
        block: 'nearest'
      });
    });
  }
  beforeDestroy() {
    this.unWatchSelector();
  }
  isCurrentSelector(selector, pseudo) {
    const {
      stylePanelState
    } = this;
    return stylePanelState.currentSelector === selector && stylePanelState.currentPseudoClass === pseudo;
  }
  renderCssEditor(style, readonly) {
    const h = this.$createElement;
    if (readonly) {
      return h(PanelStateCssEditor, {
        "class": styles.readOnlyEditor,
        "attrs": {
          "readonly": readonly,
          "value": style
        }
      });
    }
    return h(PanelStateCssEditor, {
      "attrs": {
        "enableAdvancedInlineSetting": !!this.$attrs['enable-advanced-inline-setting']
      }
    });
  }
  handleSwitchSelector(selector, pseudo) {
    this.stylePanelState.currentSelector = selector;
    this.stylePanelState.currentPseudoClass = pseudo;
    if (selector) {
      this.stylePanelState.highlightSelectedRegion();
    }
    this.$emit('highlightSelector');
  }
  /** 只读框和输入框糊到一个render里是为了点击切换的时候让VNode diff以为是数据更新 从而保证点完之后focus进去 */
  renderEditorItem(styleInfo, notSelected, showCssEditor = true) {
    const h = this.$createElement;
    const {
      selectorClass,
      pseudoClass,
      style,
      conditionStyles
    } = styleInfo;
    const selectorName = selectorClass.name || selectorClass.selector;
    const pseudoName = pseudoClass.name || pseudoClass.selector;
    const handleMouseUp = ev => {
      var _this$lastMouseup;
      if (!notSelected) return;
      if (((_this$lastMouseup = this.lastMouseup) === null || _this$lastMouseup === void 0 ? void 0 : _this$lastMouseup.target) !== ev.target) return;
      const mouseMoveDist = Math.sqrt((ev.x - this.lastMouseup.x) ** 2 + (ev.y - this.lastMouseup.y) ** 2);
      if (mouseMoveDist <= 5) {
        this.handleSwitchSelector(selectorClass.selector, pseudoClass.selector);
        // ev.stopPropagation();
      }
    };
    const notify = async ev => {
      await delay(0);
      highlightRect(invoke(this.$refs, [ev, 'scrollIntoView'], {
        block: 'nearest'
      }));
      await delay(0);
      highlightRect(invoke(this.$refs, [ev, 'getBoundingClientRect']));
    };
    const ref = `${selectorClass.selector}-${pseudoClass.selector}`;
    const condStyleRef = `${ref}-condStyleList`;
    return h("div", {
      "key": ref,
      "ref": ref,
      "class": [notSelected && styles.onlySelectedEditor]
    }, [h("div", {
      "class": styles.styleTitle
    }, [h("div", {
      "class": styles.flexTitle
    }, [h("div", {
      "class": styles.title
    }, [`${selectorName} > ${pseudoName}`]), h(SelectorRenameForm, {
      "attrs": {
        "styleInfo": styleInfo
      },
      "on": {
        "notify": notify
      }
    })]), h("div", {
      "class": styles.flexTitle
    }, [h("a-tooltip", [h("template", {
      "slot": "title"
    }, ["\u6761\u4EF6\u6837\u5F0F"]), h("a-icon", {
      "attrs": {
        "type": "plus"
      },
      "class": styles.conditionStyleButton,
      "on": {
        "click": () => {
          var _this$$refs;
          if (notSelected) this.handleSwitchSelector(selectorClass.selector, pseudoClass.selector);
          this.stylePanelState.addConditionStyleBySelector();
          ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs[condStyleRef]).showCondStyle = true;
        }
      }
    })])])]), h("div", {
      "on": {
        ...{
          "!mousedown": ev => this.lastMouseup = ev
        },
        ...{
          "!mouseup": handleMouseUp
        }
      }
    }, [(!notSelected || showCssEditor) && this.renderCssEditor(style, notSelected), h(ConditionStyleList, {
      "ref": condStyleRef,
      "attrs": {
        "conditionStyles": conditionStyles,
        "readonly": notSelected
      }
    })])]);
  }
  /** 当前正在编辑的用插槽 插进去一个PanelStateCssEditor 剩余的非空css渲染一个只读cssEditor */
  renderEditorList() {
    const {
      stylePanelState
    } = this;
    const vNodes = [];
    stylePanelState.selectors.forEach(selectorClass => {
      const {
        selector
      } = selectorClass;
      const pseudoClasses = stylePanelState.getPseudoClassesFromSelector(selector);
      pseudoClasses.forEach(pseudoClass => {
        const pseudo = pseudoClass.selector;
        const style = stylePanelState.getStylesBySelector({
          selector,
          pseudo
        });
        const conditionStyles = stylePanelState.getConditionStylesBySelector({
          selector,
          pseudo
        });
        const styleInfo = {
          selectorClass,
          pseudoClass,
          style,
          conditionStyles
        };
        if (this.isCurrentSelector(selector, pseudo)) {
          vNodes.push(() => this.renderEditorItem(styleInfo, false));
          return;
        }
        const showCssEditor = Object.keys(style).length !== 0;
        if (!showCssEditor && !stylePanelState.isConditionStyleHasEmpty(conditionStyles, false)) return;
        vNodes.push(() => this.renderEditorItem(styleInfo, true, showCssEditor));
      });
    });
    this.onlySelectedEditor = vNodes.length === 1;
    return vNodes.map(fn => fn());
  }
  render() {
    const h = arguments[0];
    const content = this.renderEditorList();
    return h("div", {
      "class": [styles.panelStateCssEditorList, !this.onlySelectedEditor && styles.multiEditor]
    }, [content]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], CssEditorList.prototype, "designer", void 0);
CssEditorList = __decorate([Component({
  name: 'CssEditorList'
})], CssEditorList);
export { CssEditorList };
//# sourceMappingURL=CssEditorList.js.map
